import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeProductRecallModal } from "../store";

import "./ProductRecallModal.css";

function ProductRecallModal() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Component mounted, modal is now rendered
  }, []);

  const show = useSelector((state) => state.appState.showProductRecallModal);

  // Lock body scroll when modal is open
  useEffect(() => {
    if (!show) return;

    // Save original styles so we can restore them later
    const originalOverflow = document.body.style.overflow;
    const originalPaddingRight = document.body.style.paddingRight;

    // Compensate for scrollbar width to avoid layout shift
    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    }

    document.body.style.overflow = "hidden";

    return () => {
      // Restore body styles when modal is closed
      document.body.style.overflow = originalOverflow;
      document.body.style.paddingRight = originalPaddingRight;
    };
  }, [show]);

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      dispatch(closeProductRecallModal());
    }
  };

  if (!show) return null;

  return (
    <div className="product-recall-modal" role="dialog" aria-modal="true" onClick={handleBackdropClick}>
      <div className="product-recall-modal__content">
        <button
          type="button"
          className="product-recall-modal__close"
          onClick={() => dispatch(closeProductRecallModal())}
          aria-label="Sulje ilmoitus"
        >
          ×
        </button>

        <h2>Palautusmenettely / takaisinveto</h2>

        <p>
          Maxxis kutsuu takaisin tietyt Premitra Ice Nord 5 -nastarenkaat
          Suomessa, koska niissä on havaittu poikkeama hyväksytyistä
          nastamäärityksistä. Tämä on mittauksissa todettu lisäävän
          tienpinnan kulumista.
        </p>

        <p>
          Osana sitoutumistamme turvallisuuteen, vastuullisuuteen ja
          asiakastyytyväisyyteen, Maxxis tarjoaa maksuttomat korvaavat
          renkaat takaisinkutsua koskeville renkaille.
        </p>

        <p>
          <strong>Renkaalla ajo ei vaaranna ajoturvallisuutta.</strong>
        </p>

        <h3>Takaisinkutsua koskeva tuote</h3>
        <ul>
          <li>
            <strong>Malli:</strong> Maxxis Premitra Ice Nord 5
          </li>
          <li>
            <strong>Koko:</strong> 205/55R16 94T
          </li>
          <li>
            <strong>Valmistusviikot:</strong> Viikko 35/2024 (3524) ja sitä
            aiemmat
          </li>
          <li>
            <strong>Myyty Suomessa:</strong> 31. elokuuta 2021 – 20.
            maaliskuuta 2025
          </li>
        </ul>

        <hr />

        <h3>
          Tarkista, koskeeko takaisinkutsu rengastasi – 3 helppoa vaihetta
        </h3>
        <ol>
          <li>
            Renkaan sivussa lukee <strong>Maxxis Premitra Ice Nord 5 (NP5)</strong>
          </li>
          <li>
            Renkaan koko on <strong>205/55R16 94T</strong>
          </li>
          <li>
            DOT-koodi päättyy <strong>3524</strong> tai pienempään numeroon
            (esimerkiksi <strong>3123</strong> tai <strong>0623</strong>)*
          </li>
        </ol>

        <p>
          Jos kaikki kolme kohtaa täyttyvät, ota yhteyttä
          Maxxis-jälleenmyyjääsi saadaksesi korvaavat renkaat veloituksetta.
        </p>

        <h3>Kysyttävää tai tarvitsetko apua?</h3>
        <p>
          Ota yhteyttä jälleenmyyjääsi tai suoraan Maxxis asiakaspalveluun:
        </p>
        <ul>
          <li>
            <strong>Puhelin:</strong>{" "}
            <a href="tel:026741650">02 674 1650</a>
          </li>
          <li>
            <strong>Sähköposti:</strong>{" "}
            <a href="mailto:vapa@vapa.fi">vapa@vapa.fi</a>
          </li>
          <li>
            <strong>Aukioloajat:</strong> MA-PE klo 08.00–16.00
          </li>
        </ul>

        <p>
          Maxxikselle turvallisuutesi ja tyytyväisyytesi ovat meille
          ensisijaisen tärkeitä. Kiitämme yhteistyöstäsi ja luottamuksestasi.
        </p>

        <img src="../../assets/images/dot-code.png" alt="DOT-koodi" />

        <p className="product-recall-modal__note">
          * DOT-koodin viimeiset neljä numeroa ilmaisevat renkaan
          valmistusviikon ja -vuoden. Tässä esimerkissä (2324) rengas on
          valmistettu vuoden 2024 viikolla 23.
        </p>
      </div>
    </div>
  );
}

export default ProductRecallModal;
